import ReviewCardWrapper from './ReviewCardWrapper.component';

export default ReviewCardWrapper;
